import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const FormDialog = styled.form``
export const DialogStyled = styled(Dialog)``
export const DialogTitleStyled = styled(DialogTitle)`
  color: ${COLORS.black};
  justify-content: center;
`
export const DialogContentStyled = styled(DialogContent)``
export const DialogActionsStyled = styled(DialogActions)``
